import { SourceApiRecord } from './interfaces';
import entityNameFromPatchPath from './patchMap';

export function siteDataResponseToEntityMap(patchData: Record<string, any>): SourceApiRecord {
    const applicator: Partial<SourceApiRecord> = {};
    const keys = Object.keys(patchData);
    for (let i = 0; i < keys.length; i++) {
        const patchPath = keys[i];

        if (patchPath === 'hash') {
            continue;
        }

        let items = patchData[patchPath];

        /* '/site' comes back as an Object, not an array. make sure all added are arrays */
        if (!Array.isArray(items)) {
            items = [items];
        }

        const entityName = entityNameFromPatchPath(patchPath);

        if (!entityName) {
            continue;
        }

        applicator[entityName] = items;
    }

    return applicator as SourceApiRecord;
}
